import React from "react";
import "../../../css/Transparencia/memoria.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

const ANIOS = [2025, 2024, 2023, 2022, 2021, 2020];

const urlPDF = (anio) =>
  `http://ciudaddeoliva.gov.ar/file/pdf/web-oliva/memoria/MEMORIA-OI-${anio}.pdf`;

const Memoria = () => (
  <div className="memoria-full-bg">
    <div className="memoria-container">
      <h1 className="memoria-title">MEMORIAS</h1>
      <h2 className="memoria-subtitle">
        Memorias Descriptivas de la Gestión Municipal
      </h2>
      <div className="memoria-list">
        {ANIOS.map((anio) => (
          <a
            key={anio}
            href={urlPDF(anio)}
            target="_blank"
            rel="noopener noreferrer"
            className="memoria-btn"
          >
            <FontAwesomeIcon icon={faPaperclip} className="memoria-btn-icon" />
            MEMORIA {anio}
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default Memoria;
